import React from 'react';
import Header from '../../Components/Header/Header';
import Calendar from '../../Components/Calendar/Calendar';
import stationDataAPI from '../../Utils/stationDataAPI';
//import getUrlParam from 'Utils/UrlParamsModule';

import './CalendarScreen.css'

let moment = require('moment');


class CalendarScreen extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            stations: null,
            currentDate: moment(),      //CHANHE (switch to current time)
            selectedDate: null,
            locationID: "",
            showHeader: true
        }

        this.processDates = this.processDates.bind(this);
    }

    componentDidMount() {
        let date = moment();

        this.processDates(date);
    }

    async processDates(date) {

        let masterStationData = [];
        let stationData = [];
        let formattedDate = date.format('YYYY-MM-DD');
        let selectedMonth = Number(date.format("M"));
        
        let locationID;
        let strings = window.location.href.split('/');
        if ((strings[4] !== undefined || strings[4] !== null) && strings.length > 4)  {

            if (strings[4] === "") {
                locationID = 1;
            } else {
                locationID = Number(strings[4]);
            }
        } else {
            locationID = 1;
        }
        let locationName = "";

        if(strings.length > 5 && strings[5] === "1") {
            this.setState({
                showHeader: false
            });
        }
        
        //if picking a date after the current date
        //else if picking a date in the same month
        let day = 0;
        if (this.state.currentDate.isBefore(date, 'month')) {
            day = 1;
        } else {
            day = Number(moment().format('D'));
        }

        formattedDate = formattedDate.split('-');
        let finalFormattedDate = formattedDate[0] + '-' + formattedDate[1] + '-' + day;
        // console.log("final formatted date: ", finalFormattedDate);

        //before getting new info, begin by deleting percents on previous dates

        try {
            let stationResult =
                await stationDataAPI
                    .getAvailableMonthStations(
                        locationID,
                        finalFormattedDate
                    )

            // console.log("STATION RESULT: ", stationResult);

            //handle case of no data -> too much into future
            //handle case of past date (ie for going back in months)
            if (stationResult.result[0].json_build_object.timeslots === null
                || date.isBefore(this.state.currentDate, 'month')) {
                    console.log("no data ? ?");
                this.setState({
                    stations: [],
                    selectedDate: moment(date),
                    locationID: locationID,
                    locationName: ""
                });
            } else {
                //begin by creating an array of objects with the timeslots of the next day APPENDED to the timeslots of that day
                masterStationData = stationResult.result[0].json_build_object.timeslots;
                masterStationData = masterStationData.sort(function(a, b){return new Date(a.time)-new Date(b.time)});
                // console.log("master station data pre: ", masterStationData);
                for (let i = 0; i < masterStationData.length; i++) {
                    if (masterStationData[i + 1] !== undefined && masterStationData[i + 1] !== null) {
                        //if there's another timeslot behind it, append it
                        let tempSpot = masterStationData[i].json_agg.concat(masterStationData[i + 1].json_agg);
                        masterStationData[i].json_agg = tempSpot;
                        // console.log(`master station #${i}`, masterStationData[i]);
                    }
                }
                // console.log("MASTER STATIONS DATA ARRAY: ", masterStationData);

                //process result's data into an array, where each index is a day in the month, and each index has an interable list of slots
                //get each day into its own index: don't need to care about days outside of months as we will requery if they press day outside current month
                //in fact; we will filter out days outside the month
                //NOTE: NEED TO GET INSIDE THE OBJECT'S DATE FOR DAY
                // stationResult.result[0].json_build_object.timeslots.map(day => {
                masterStationData.forEach(day => {
                    //first check if day is within the month
                    if (Number(moment(day.json_agg[0].time).format('M')) === selectedMonth) {
                        let day_number = Number(moment(day.json_agg[0].time).format('DD'));
                        stationData[day_number] = day;
                    }
                });
                // console.log("Stations data with days only in this month: ", stationData);

                //for each day in stationData, turn the timeslots into an iterateable list
                stationData = stationData.map(day => day.json_agg);
                // console.log("completed station result: ", stationData);

                //get name of location
                locationName = stationResult.result[0].json_build_object.name;

                //update state
                this.setState({
                    stations: stationData,
                    selectedDate: moment(date),
                    locationID: locationID,
                    locationName: locationName
                });


            }

        }
        catch (error) {
            console.log(error)
        }
    }

    removeFillerData = () => {
        let days = Array.from(document.getElementsByClassName('percent-filled'));
        days.forEach(day => day.removeChild(day.childNodes[1]));
    }

    render() {
        let display = (this.state.stations == null)
            ? null
            : <div className="body-item">
                <Calendar
                    stationData={this.state.stations}
                    currentDate={this.state.currentDate}
                    selectedDate={this.state.selectedDate}
                    handleNewData={this.processDates}
                    locationID={this.state.locationID}
                    locationName={this.state.locationName}
                />
            </div>

        return (
            <div>
                { this.state.showHeader ? 
                    <Header />
                    : null
                }
                {display}
            </div>
        )
    }
}

export default CalendarScreen;